import { z } from 'zod';

export interface StreetAddress {
    id?: number;
    /**
     * Street address
     */
    address_1: string;

    /**
     * Apartment number
     */
    address_2?: string;

    /**
     * @deprecated This was erroneously used for apartment number but that has
     * now been updated on the back end.
     */
    address_3?: string;
    city: string;
    state: string;
    zip: string;
    lat: string;
    lng: string;
}

const $s = z.string();

const $streetAddress = z.object({
    id: z.number().optional(),
    address_1: $s,
    address_2: $s.optional(),
    address_3: $s.optional(),
    city: $s,
    state: $s,
    zip: $s,
    lat: $s,
    lng: $s
});

export interface UserInfo {
    phone: string;
    fname?: string; // Checkout only
    lname?: string; // Checkout only
    email?: string; // Checkout only
}

export const $userInfo: z.Schema<UserInfo> = z.object({
    phone: $s,
    fname: $s.optional(),
    lname: $s.optional(),
    email: $s.email()
});

export interface Address extends StreetAddress {
    phone?: string;
    ext?: string;
    company?: string;
    address_name?: string;
    comments?: string;
}

export const $address = $streetAddress.extend({
    phone: $s.optional(),
    ext: $s.optional(),
    company: $s.optional(),
    address_name: $s.optional(),
    comments: $s.optional()
});

export interface DeliveryCheckPayload {
    storeId?: number;
    distance?: number;
    willDeliver: boolean;
    waitTime?: string;
    inDeliveryArea: boolean;
    isOpen: boolean;
}

export const toPoint = (address: StreetAddress) => ({
    lat: parseFloat(address.lat),
    lng: parseFloat(address.lng)
});

export const isFullAddress = (address: StreetAddress | Address | undefined): address is Address => {
    if (!address) {
        return false;
    }
    return 'id' in address;
};

export const formatDeliveryAddress = (address?: StreetAddress): string | undefined => {
    if (!address) {
        return undefined;
    }
    if (isAddressEmpty(address)) {
        return undefined;
    }

    if (!address.address_2) {
        return address.address_1;
    }

    return `${address.address_1}, ${address.address_2}`;
};

export const isAddressEmpty = (address: Address | StreetAddress) => {
    return Object.values(address).every(
        (value) => value === undefined || value.toString().trim() === ''
    );
};
